import moment from "moment"
import { useContext, useState } from "react"
import { Modal } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { Calendar } from "react-feather"
import { SystemMessageContext } from "../../../context/SystemMessageContext"
import campaignStatuses from "../../../data/campaignStatuses"
import callAPI from "../../../helpers/callAPI"
import ScheduleRelaunchContent from "./ScheduleRelaunchContent"

const ScheduleRelaunchModal = ({ isOpen, handleClose, campaignId, refetch }) => {
    return (
        <Modal show={isOpen} onHide={handleClose}>
            <ScheduleRelaunchContent isOpen={isOpen} handleClose={handleClose} campaignId={campaignId} refetch={refetch} />
        </Modal>
    )
}

export default ScheduleRelaunchModal